import { useTheme } from '../lib/theme-provider';
import { AlertTriangle, X } from 'lucide-react';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = '确认',
  cancelText = '取消',
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 pb-24"
      onClick={onCancel}
    >
      <div
        className="rounded-xl p-5 w-full max-w-sm mb-16"
        style={{ backgroundColor: theme.colors['bg-card'] }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <AlertTriangle
              size={20}
              style={{ color: theme.colors['accent-gold'] }}
            />
            <h3
              className="font-semibold text-lg"
              style={{ color: theme.colors['text-primary'] }}
            >
              {title}
            </h3>
          </div>
          <button
            onClick={onCancel}
            className="p-1 rounded-lg hover:opacity-70 transition-opacity"
          >
            <X size={20} style={{ color: theme.colors['text-secondary'] }} />
          </button>
        </div>

        <p
          className="text-sm mb-6"
          style={{ color: theme.colors['text-secondary'] }}
        >
          {message}
        </p>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-2.5 rounded-xl font-medium text-sm transition-colors"
            style={{
              backgroundColor: `${theme.colors['bg-primary']}80`,
              color: theme.colors['text-primary'],
              border: `1px solid ${theme.colors['border-secondary']}`,
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-xl font-medium text-sm transition-colors"
            style={{
              backgroundColor: theme.colors['accent-gold'],
              color: theme.colors['bg-primary'],
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
